// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27%23000%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1L5 5L9 1%27 stroke=%27%23555%27 stroke-width=%271.5%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` * {
     box-sizing: border-box;
     font-family: "Noto Sans KR", sans-serif;
 }

 body {
     margin: 0;
     /* 2025.10.28 background 삭제 */
 }

 /* 2025.10.23 로그인 화면 */

 .login-container {
     display: flex;
     justify-content: center;
     align-items: center;
     height: 100vh;
     /* 중앙 정렬용 */
 }

 .login-box {
     width: 420px;
     /* 👉 원하는 가로 넓이 지정 */
     background: #fff;
     padding: 40px 30px;
     border: 1px solid #ddd;
     box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
     text-align: center;
     border-radius: 4px;
 }

 .logo {
     width: 250px;
     margin-bottom: 20px;
 }

 .login-section {
     text-align: left;
 }

 .login-label {
     font-size: 14px;
     color: #333;
     display: block;
     margin-bottom: 6px;
 }

 input[type="id"],
 input[type="password"] {
     width: 100%;
     padding: 10px;
     border: 1px solid #8c8f94;
     border-radius: 3px;
     margin-bottom: 14px;
     font-size: 14px;
 }

 .password-wrap {
     position: relative;
 }

 .toggle-password {
     position: absolute;
     right: 10px;
     top: 7px;
     background: none;
     border: none;
     cursor: pointer;
     font-size: 16px;
     color: #555;
 }

 .remember {
     display: flex;
     align-items: center;
     margin-bottom: 20px;
 }

 .remember label {
     margin: 0 0 0 6px;
     font-size: 13px;
     color: #555;
 }

 .login-btn {
     width: 100%;
     background-color: #2271b1;
     color: #fff;
     border: none;
     border-radius: 3px;
     padding: 10px 0;
     font-size: 15px;
     cursor: pointer;
 }

 .login-btn:hover {
     background-color: #135e96;
 }

 .back {
     display: inline-block;
     margin-top: 16px;
     font-size: 13px;
     color: #2271b1;
     text-decoration: none;
 }

 .back:hover {
     text-decoration: underline;
 }


 /* 2025.10.20 제품관리 css 작성중 */
 .manager-header {
     display: flex;
     justify-content: space-between;
     background-color: #6b93b0;
     color: #fff;
     padding: 10px 20px;
     font-size: 18px;
     align-items: center;
 }

 /* 2025.10.27 lang 변경 */
  .lang {
     display: flex;
     align-items: center;
     height: 40px;
 }

 .lang select {
     margin: 0;
     padding: 6px 30px 6px 10px;
     font-size: 14px;
     border: 0.5px solid #ccc;
     border-radius: 6px;
     height: 36px;
     line-height: 1.2;
     box-sizing: border-box;
     background-color: #fff;
     appearance: none;
     -webkit-appearance: none;
     -moz-appearance: none;
     background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 5px center;
     background-color: #fff;
 }


 .manager-nav {
     display: flex !important;
     background: #5c88ab;
     text-align: center;
 }

 .manager-nav .admin-menu {
     flex: 1;
     background: transparent;
     color: #fff;
     padding: 12px;
     font-size: 16px;
     border: none;
     cursor: pointer;
 }

 .manager-nav .admin-menu.selected {
     font-weight: bold;
     background: #4e7394;
 }

 .product-manager {
     display: flex;
     padding: 20px;
     gap: 20px;
     align-items: flex-start;
 }

 /* 제품 목록 */
 .product-list {
     background: #6b93b0;
     color: #fff;
     padding: 20px;
     width: 220px;
     display: flex;
     flex-direction: column;
     justify-content: space-between;
     border-radius: 4px;

     position: sticky;
     top: 20px;
     /* 스크롤 시 상단에서 20px 떨어진 상태로 고정 */
     align-self: flex-start;
 }

 .product-list h2 {
     text-align: center;
     margin-top: 0;
 }

 .product-list ul {
     list-style: none;
     padding: 0;
     background: rgba(255, 255, 255, 0.1);
     margin: 10px 0;
     height: 280px;
     overflow-y: auto;
 }

 .product-list li {
     padding: 8px 12px;
     border-bottom: 1px solid rgba(255, 255, 255, 0.2);
     cursor: pointer;
 }

 /* 신규 버튼 */
 .new-btn {
     align-self: flex-end;
     background: #4e7394;
     color: #fff;
     border: none;
     padding: 8px 14px;
     cursor: pointer;
     border-radius: 4px;
 }

 /* 제품 상세 */
 .product-detail {
     flex: 1;
     background: #fff;
     padding: 20px;
     border: 1px solid #d0d7de;
     border-radius: 4px;
 }

 .form-row {
     display: flex;
     align-items: center;
     margin-bottom: 12px;
 }

 .form-row label {
     width: 80px;
     flex-shrink: 0;
 }

 .form-row input[type="text"],
 .form-row textarea {
     flex: 1;
     padding: 6px;
     border: 1px solid #ccc;
     border-radius: 4px;
 }

 .form-row textarea {
     height: 60px;
     resize: vertical;
 }

 .form-row select {
     flex: 0 0 250px;
     /* 가로 폭 줄이기 */
     padding: 6px 32px 6px 10px;
     /* 오른쪽에 여백 줘서 화살표 안겹치게 */
     border: 1px solid #ccc;
     border-radius: 4px;
     background-color: #fff;
     appearance: none;
     -webkit-appearance: none;
     -moz-appearance: none;
     background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
     background-repeat: no-repeat;
     background-position: right 12px center;
     background-size: 10px 6px;
     cursor: pointer;
 }

 .form-row select:focus {
     outline: none;
     border-color: #4e7394;
     box-shadow: 0 0 0 2px rgba(78, 115, 148, 0.2);
 }

 /* 메인사진 영역 */
 .main-photo-row {
     align-items: flex-start;
 }

 .main-photo-wrap {
     flex: 1;
     display: flex;
     flex-direction: column;
     gap: 8px;
     padding-bottom: 18px;
 }

 .main-photo-wrap input[type="file"] {
     border: 1px solid #ccc;
     border-radius: 4px;
     padding: 6px;
     background: #ffffff;
 }

 .main-photo-preview {
     width: 100%;
     min-height: 180px;
     border: 1px solid #ccc;
     border-radius: 6px;
     background: #f6f8fb;
     display: flex;
     justify-content: center;
     align-items: center;
     overflow: hidden;
     text-align: center;
     color: #777;
 }

 .main-photo-preview img {
     max-width: 100%;
     max-height: 100%;
     object-fit: contain;
     border-radius: 4px;
 }

 .img-btn {
     margin-left: 10px;
     padding: 6px 10px;
     background: #4e7394;
     color: #fff;
     border: none;
     border-radius: 4px;
     cursor: pointer;
 }

 .file-info {
     font-size: 13px;
     color: #555;
 }

 .file-item {
     display: flex;
     align-items: center;
     gap: 4px;
     padding: 4px 0;
     font-size: 14px;
     line-height: 1.4;
 }

 .file-item svg {
     width: 14px;
     height: 14px;
     flex-shrink: 0;
     vertical-align: middle;
     margin-top: -0.5px;
 }

 .file-item .file-name {
     flex: none;
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     color: #0048ff;
     cursor: pointer;
     margin-right: 4px;
     display: flex;
     align-items: center;
 }

 .file-item .remove-btn {
     color: #999;
     background: none;
     border: none;
     font-size: 15px;
     cursor: pointer;
     padding: 0 2px;
     line-height: 1;
     display: flex;
     align-items: center;
     justify-content: center;
     transition: 0.2s;
 }

 .file-item .remove-btn:hover {
     color: #ff4444;
 }

 /* 2025.10.27 class 변경 */
 .file-row {
     display: flex;
 }

 .file-row>.file-item {
     margin-right: 8px;
 }

 /* 미리보기 행 확장 */
 .preview-row {
     align-items: flex-start;
     padding-top: 18px;
 }

 /* 기존 editor-area 대신 새 preview-area */
 .preview-area {
     flex: 1;
     border: 1px solid #ccc;
     border-radius: 6px;
     background-color: #f6f8fb;
     padding: 20px;
     text-align: center;
     color: #555;
     min-height: 300px;
     /* 기본 높이 크게 */
     display: flex;
     justify-content: center;
     align-items: center;
     overflow: hidden;
     flex-direction: column;
 }

 /* 업로드된 이미지 미리보기용 */
 .preview-area img {
     max-width: 100%;
     max-height: 100%;
     object-fit: contain;
     border-radius: 4px;
 }

 /* 하단 버튼 */
 .footer-row {
     display: flex;
     justify-content: space-between;
     margin-top: 20px;
     align-items: center;
 }

 .btn-group {
     display: flex;
     gap: 8px;
 }

 .edit-btn,
 .delete-btn {
     padding: 8px 16px;
     border: none;
     cursor: pointer;
     border-radius: 4px;
 }

 .edit-btn {
     background: #4e7394;
     color: #fff;
 }

 .delete-btn {
     background: #ccc;
     color: #000;
 }

 /* 게시판 관리 css 작성중 */

 /* 메인 영역 */
 .admin-body {
     display: flex;
     padding: 20px;
     gap: 20px;
 }

 .board-settings h3 {
     font-size: 14px;
     margin-bottom: 10px;
 }

 .board-settings input[type="text"] {
     width: 100%;
     padding: 6px;
     margin: 4px 0 10px 0;
 }

 /* 게시판 메인 */
 .board-main {
     flex: 1;
     background: #fff;
     padding: 15px;
     border-radius: 8px;
 }

  .board-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
  }

 .board-header h4 {
     font-size: 16px;
     margin-bottom: 10px;
 }

 .board-table {
     width: 100%;
     border-collapse: collapse;
     table-layout: fixed;
 }

 .board-table th,
 .board-table td {
     border: 1px solid #ccc;
     padding: 8px;
     text-align: center;
     padding: 8px 12px;
     text-align: center;
     border: 1px solid #ddd;
     overflow: hidden;
     text-overflow: ellipsis;
     /* 내용이 길면 ... 처리 */
     white-space: nowrap;
     /* 줄 바꿈 방지 */
 }

 /* 특정 컬럼 너비 조정 */
 .board-table th:nth-child(1),
 /* 조회수 */
 .board-table td:nth-child(1) {
     width: 50px;
 }


 /* 특정 컬럼 너비 조정 */
 .board-table th:nth-child(3),
 /* 조회수 */
 .board-table td:nth-child(3) {
     width: 100px;
 }

 .board-table th:nth-child(4),
 /* 생성시간 */
 .board-table td:nth-child(4) {
     width: 100px;
 }

 .board-table th:nth-child(5),
 /* 답글 */
 .board-table td:nth-child(5) {
     width: 100px;
 }

 .board-table th:nth-child(6),
 /* 첨부 */
 .board-table td:nth-child(6) {
     width: 100px;
 }

 .board-table th {
     background: #f0f4f8;
 }

 .footer-box {
     display: flex;
     justify-content: flex-end;
     /* 내부 콘텐츠를 오른쪽으로 */
     margin-top: 16px;
     /* 위쪽 여백 (선택사항) */
 }


 /* 검색창 */
 .search-area {
     margin-top: 12px;
     text-align: center;
 }

 .search-area input {
     padding: 8px;
     width: 300px;
     max-width: 100%;
     border: 1px solid #ccc;
     border-radius: 4px;
 }

 /* 페이지네이션 */
 /* 2025.10.31 */
 /* .edit-pagination {
     display: flex;
     justify-content: center;
     align-items: center;
     gap: 15px;
     margin: 25px 0 0;
     padding-bottom: 20px;
 }

 .edit-pagination button {
     background: none;
     border: none;
     font-size: 1rem;
     cursor: pointer;
     color: #000;
 }

 .edit-pagination .active {
     font-weight: 500;
     text-decoration: underline;
 } */

 .btn-group {
     display: flex;
     justify-content: flex-end;
     /* 오른쪽 정렬 */
     gap: 8px;
 }

 /* 섹션 구분 */
 .board-section {
     border: 1px solid #cfd6e3;
     padding: 20px;
     margin-bottom: 25px;
     border-radius: 6px;
 }

 /* 행 정렬 */
 .row {
     display: flex;
     align-items: center;
     margin-bottom: 8px;
 }

 .row label {
     font-size: 14px;
     color: #222;
     width: 80px;
     flex-shrink: 0;
 }

 .right {
     font-size: 14px;
     color: #444;
 }

 .row input[type="text"],
 .row textarea {
     flex: 1;
     padding: 6px;
     border: 1px solid #ccc;
     border-radius: 4px;
 }

 .row textarea {
     height: 400px;
     resize: vertical;
 }

 .row-file {
     display: flex;
     align-items: center;
     text-align: center;
     margin-bottom: 8px;
 }

 /* 2025.10.29 수정 */
  .row-file label {
    font-size: 14px;
     color: #222;
     margin-right: 8px;

 }

 /* 내용 박스 */
 .content-box {
     border: 1px solid #99a3b3;
     height: 120px;
     border-radius: 4px;
     margin: 8px 0 16px;
 }

 /* 2025.10.27 css 추가 */
 .board-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
 }

 /* 버튼 */
 .btn-box {
     text-align: right;
 }

 .btn-box button {
     border: 1px solid #6b7a90;
     background: #fff;
     border-radius: 4px;
     padding: 4px 10px;
     margin-left: 5px;
     cursor: pointer;
 }

 .btn-box button:hover {
     background: #e8edf4;
 }

 /* 첨부파일 */
 /* 2025.10.27 class명 변경 */
 .row-detail-file {
    /* 2025.10.25 margin값 변경 */
     margin-left: 20px;
     text-align: right;
 }

 .row-detail-file a {
     display: inline-block;
     padding: 6px 10px;
     border: 1px solid #ccc;
     border-radius: 4px;
     font-size: 14px;
     color: #0048FF;
     text-decoration: none;
     background: #f9f9f9;
 }


 .row-detail-file svg {
     flex-shrink: 0;
     vertical-align: middle;
 }

 /* 2025.10.25 메뉴 관리 페이지 css 작성 */

 /* 메뉴 사이드바 */
 .menu-sidebar {
     background-color: #6b93b0;
     color: #fff;
     width: 220px;
     padding: 20px;
     display: flex;
     flex-direction: column;
     justify-content: space-between;
     border-radius: 6px;
     position: sticky;
     top: 20px;
     align-self: flex-start;
 }

 /* 제목 */
 .menu-title {
     text-align: center;
     margin-top: 0;
     margin-bottom: 10px;
     font-size: 22px;
     font-weight: 700;
     margin-bottom: 16px;
 }

 /* 메뉴 리스트 */
 .menu-list {
     list-style: none;
     padding: 0;
     margin: 0;
     background: rgba(255, 255, 255, 0.1);
     /* 2025.10.31 */
     height: 100%;
     overflow-y: auto;
     border-radius: 4px;
 }

 /* 상위 메뉴 항목 */
 .menu-item {
     padding: 8px 12px;
     border-bottom: 1px solid rgba(255, 255, 255, 0.2);
     cursor: pointer;
     position: relative;
 }

 /* 상위 메뉴 항목 */
 .menu-item {
     position: relative;
     padding: 10px 12px;
     /* 오른쪽 여백 확보 */
     border-bottom: 1px solid rgba(255, 255, 255, 0.2);
     cursor: pointer;
     line-height: 1.4;
 }

 /* 화살표 고정 */
 .arrow {
     position: absolute;
     right: 10px;
     top: 12px;
     /* 세로 중앙 정렬 */
     transform: none;
     font-size: 0.8em;
     transition: transform 0.3s ease;
     opacity: 0.8;
     pointer-events: none;
     /* 클릭 방해 금지 */
     z-index: 2;
     /* 스크롤 영역 안에서도 고정 */
 }

 /* 2025.10.27 plus 추가 */
 .plus {
     position: absolute;
     right: 10px;
 }

 /* 펼쳐졌을 때 회전 */
 .menu-item.active .arrow {
     transform: rotate(-180deg);
 }

 /* 서브메뉴 (아코디언 숨김) */
 .submenu-list {
     display: none;
     list-style: none;
     padding-left: 15px;
     margin-top: 5px;
     max-height: 0;
     overflow: hidden;
     transition: max-height 0.3s ease;
 }

 .menu-item.active .submenu-list {
     display: block;
 }

 /* 펼쳐졌을 때 */
 .menu-item.active .submenu-list {
     max-height: 300px;
     /* 충분한 높이 */
 }

 /* 서브 항목 */
 .submenu-item {
     padding: 10px 10px;
     cursor: default;
     font-size: 0.95em;
     cursor: pointer;
 }

 /* 버튼 */
 .btn-add {
     align-self: flex-end;
     background: #4e7394;
     color: #fff;
     border: none;
     padding: 8px 14px;
     cursor: pointer;
     border-radius: 4px;
     margin-top: 5px;
 }

 /* 스크롤바 스타일 */
 .menu-list::-webkit-scrollbar {
     width: 6px;
 }

 .menu-list::-webkit-scrollbar-thumb {
     background-color: rgba(255, 255, 255, 0.3);
     border-radius: 3px;
 }

 /* 2025.10.28 메뉴 팝업 수정 */
 /* 메뉴 팝업 */
/* 모달 기본 */
.menu-modal {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.menu-modal-content {
  background: #fff;
  width: 600px;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  max-height: 80vh;
  overflow-y: auto;
}

.menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f2f4f8;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
}

/* 2025.10.29 수정 */
.submenu-modal {
  margin: 8px 0 15px 20px;
  padding: 0;
  list-style: none;
  display: none; /* 기본은 접힘 */
}

.submenu-modal > li {
    margin-bottom: 8px;
     display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f2f4f8;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
}

.menu-item.open .submenu-list {
  display: block; /* 열리면 표시 */
}

.sort-btns button {
  background: #6b93b0;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 3px 6px;
  cursor: pointer;
}

.sort-btns button:hover {
  background: #587d95;
}

.modal-buttons {
  text-align: right;
  margin-top: 10px;
}

.modal-buttons button {
  background: #6b93b0;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 8px 14px;
  margin-left: 10px;
  cursor: pointer;
}

.modal-buttons .close-menu-modal {
  background: #aaa;
}

/* 2025.10.25 제품관리 테이블 추가 */
.product-table {
     width: 100%;
     border-collapse: collapse;
     table-layout: fixed;
 }

 .product-table th,
 .product-table td {
     border: 1px solid #ccc;
     padding: 8px;
     text-align: center;
     padding: 8px 12px;
     text-align: center;
     border: 1px solid #ddd;
     overflow: hidden;
     text-overflow: ellipsis;
     /* 내용이 길면 ... 처리 */
     white-space: nowrap;
     /* 줄 바꿈 방지 */
 }

 /* 특정 컬럼 너비 조정 */
 .product-table th:nth-child(1),
 .product-table td:nth-child(1) {
     width: 20px;
 }

 .product-table th:nth-child(2),
 .product-table td:nth-child(2) {
     width: 100px;
 }

  .product-table th:nth-child(3),
 .product-table td:nth-child(3) {
     width: 200px;
 }

   .product-table th:nth-child(4),
 .product-table td:nth-child(4) {
     width: 150px;
 }
 
    .product-table th:nth-child(5),
 .product-table td:nth-child(5) {
     width: 50px;
 }

    .product-table th:nth-child(6),
 .product-table td:nth-child(6) {
     width: 150px;
 }

     .product-table th:nth-child(7),
 .product-table td:nth-child(7) {
     width: 40px;
 }



 .product-table th {
     background: #f0f4f8;
 }

  .product-preview {
     align-items: center;
 }

 /* 업로드된 이미지 미리보기용 */
 .product-preview img {
     max-width: 25%;
     max-height: 25%;
     object-fit: contain;
     border-radius: 4px;
 }

 .Caution {
    font-size: 12px;
    color: #d80a0a;
 }

 .manager-btn {
    display: flex;
    align-items: center;
 }

 .title {
    margin-right: 16px;
 }`, "",{"version":3,"sources":["webpack://./static/css/manager.css"],"names":[],"mappings":"CAAC;KACI,sBAAsB;KACtB,uCAAuC;CAC3C;;CAEA;KACI,SAAS;KACT,6BAA6B;CACjC;;CAEA,sBAAsB;;CAEtB;KACI,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,aAAa;KACb,WAAW;CACf;;CAEA;KACI,YAAY;KACZ,oBAAoB;KACpB,gBAAgB;KAChB,kBAAkB;KAClB,sBAAsB;KACtB,yCAAyC;KACzC,kBAAkB;KAClB,kBAAkB;CACtB;;CAEA;KACI,YAAY;KACZ,mBAAmB;CACvB;;CAEA;KACI,gBAAgB;CACpB;;CAEA;KACI,eAAe;KACf,WAAW;KACX,cAAc;KACd,kBAAkB;CACtB;;CAEA;;KAEI,WAAW;KACX,aAAa;KACb,yBAAyB;KACzB,kBAAkB;KAClB,mBAAmB;KACnB,eAAe;CACnB;;CAEA;KACI,kBAAkB;CACtB;;CAEA;KACI,kBAAkB;KAClB,WAAW;KACX,QAAQ;KACR,gBAAgB;KAChB,YAAY;KACZ,eAAe;KACf,eAAe;KACf,WAAW;CACf;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,mBAAmB;CACvB;;CAEA;KACI,iBAAiB;KACjB,eAAe;KACf,WAAW;CACf;;CAEA;KACI,WAAW;KACX,yBAAyB;KACzB,WAAW;KACX,YAAY;KACZ,kBAAkB;KAClB,eAAe;KACf,eAAe;KACf,eAAe;CACnB;;CAEA;KACI,yBAAyB;CAC7B;;CAEA;KACI,qBAAqB;KACrB,gBAAgB;KAChB,eAAe;KACf,cAAc;KACd,qBAAqB;CACzB;;CAEA;KACI,0BAA0B;CAC9B;;;CAGA,4BAA4B;CAC5B;KACI,aAAa;KACb,8BAA8B;KAC9B,yBAAyB;KACzB,WAAW;KACX,kBAAkB;KAClB,eAAe;KACf,mBAAmB;CACvB;;CAEA,uBAAuB;EACtB;KACG,aAAa;KACb,mBAAmB;KACnB,YAAY;CAChB;;CAEA;KACI,SAAS;KACT,0BAA0B;KAC1B,eAAe;KACf,wBAAwB;KACxB,kBAAkB;KAClB,YAAY;KACZ,gBAAgB;KAChB,sBAAsB;KACtB,sBAAsB;KACtB,gBAAgB;KAChB,wBAAwB;KACxB,qBAAqB;KACrB,8EAAuM;KACvM,sBAAsB;CAC1B;;;CAGA;KACI,wBAAwB;KACxB,mBAAmB;KACnB,kBAAkB;CACtB;;CAEA;KACI,OAAO;KACP,uBAAuB;KACvB,WAAW;KACX,aAAa;KACb,eAAe;KACf,YAAY;KACZ,eAAe;CACnB;;CAEA;KACI,iBAAiB;KACjB,mBAAmB;CACvB;;CAEA;KACI,aAAa;KACb,aAAa;KACb,SAAS;KACT,uBAAuB;CAC3B;;CAEA,UAAU;CACV;KACI,mBAAmB;KACnB,WAAW;KACX,aAAa;KACb,YAAY;KACZ,aAAa;KACb,sBAAsB;KACtB,8BAA8B;KAC9B,kBAAkB;;KAElB,gBAAgB;KAChB,SAAS;KACT,+BAA+B;KAC/B,sBAAsB;CAC1B;;CAEA;KACI,kBAAkB;KAClB,aAAa;CACjB;;CAEA;KACI,gBAAgB;KAChB,UAAU;KACV,oCAAoC;KACpC,cAAc;KACd,aAAa;KACb,gBAAgB;CACpB;;CAEA;KACI,iBAAiB;KACjB,iDAAiD;KACjD,eAAe;CACnB;;CAEA,UAAU;CACV;KACI,oBAAoB;KACpB,mBAAmB;KACnB,WAAW;KACX,YAAY;KACZ,iBAAiB;KACjB,eAAe;KACf,kBAAkB;CACtB;;CAEA,UAAU;CACV;KACI,OAAO;KACP,gBAAgB;KAChB,aAAa;KACb,yBAAyB;KACzB,kBAAkB;CACtB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,mBAAmB;CACvB;;CAEA;KACI,WAAW;KACX,cAAc;CAClB;;CAEA;;KAEI,OAAO;KACP,YAAY;KACZ,sBAAsB;KACtB,kBAAkB;CACtB;;CAEA;KACI,YAAY;KACZ,gBAAgB;CACpB;;CAEA;KACI,eAAe;KACf,aAAa;KACb,0BAA0B;KAC1B,wBAAwB;KACxB,sBAAsB;KACtB,kBAAkB;KAClB,sBAAsB;KACtB,gBAAgB;KAChB,wBAAwB;KACxB,qBAAqB;KACrB,yDAAiO;KACjO,4BAA4B;KAC5B,sCAAsC;KACtC,yBAAyB;KACzB,eAAe;CACnB;;CAEA;KACI,aAAa;KACb,qBAAqB;KACrB,6CAA6C;CACjD;;CAEA,YAAY;CACZ;KACI,uBAAuB;CAC3B;;CAEA;KACI,OAAO;KACP,aAAa;KACb,sBAAsB;KACtB,QAAQ;KACR,oBAAoB;CACxB;;CAEA;KACI,sBAAsB;KACtB,kBAAkB;KAClB,YAAY;KACZ,mBAAmB;CACvB;;CAEA;KACI,WAAW;KACX,iBAAiB;KACjB,sBAAsB;KACtB,kBAAkB;KAClB,mBAAmB;KACnB,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,gBAAgB;KAChB,kBAAkB;KAClB,WAAW;CACf;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,mBAAmB;KACnB,kBAAkB;CACtB;;CAEA;KACI,iBAAiB;KACjB,iBAAiB;KACjB,mBAAmB;KACnB,WAAW;KACX,YAAY;KACZ,kBAAkB;KAClB,eAAe;CACnB;;CAEA;KACI,eAAe;KACf,WAAW;CACf;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,QAAQ;KACR,cAAc;KACd,eAAe;KACf,gBAAgB;CACpB;;CAEA;KACI,WAAW;KACX,YAAY;KACZ,cAAc;KACd,sBAAsB;KACtB,kBAAkB;CACtB;;CAEA;KACI,UAAU;KACV,gBAAgB;KAChB,uBAAuB;KACvB,mBAAmB;KACnB,cAAc;KACd,eAAe;KACf,iBAAiB;KACjB,aAAa;KACb,mBAAmB;CACvB;;CAEA;KACI,WAAW;KACX,gBAAgB;KAChB,YAAY;KACZ,eAAe;KACf,eAAe;KACf,cAAc;KACd,cAAc;KACd,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,gBAAgB;CACpB;;CAEA;KACI,cAAc;CAClB;;CAEA,wBAAwB;CACxB;KACI,aAAa;CACjB;;CAEA;KACI,iBAAiB;CACrB;;CAEA,cAAc;CACd;KACI,uBAAuB;KACvB,iBAAiB;CACrB;;CAEA,qCAAqC;CACrC;KACI,OAAO;KACP,sBAAsB;KACtB,kBAAkB;KAClB,yBAAyB;KACzB,aAAa;KACb,kBAAkB;KAClB,WAAW;KACX,iBAAiB;KACjB,aAAa;KACb,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,gBAAgB;KAChB,sBAAsB;CAC1B;;CAEA,mBAAmB;CACnB;KACI,eAAe;KACf,gBAAgB;KAChB,mBAAmB;KACnB,kBAAkB;CACtB;;CAEA,UAAU;CACV;KACI,aAAa;KACb,8BAA8B;KAC9B,gBAAgB;KAChB,mBAAmB;CACvB;;CAEA;KACI,aAAa;KACb,QAAQ;CACZ;;CAEA;;KAEI,iBAAiB;KACjB,YAAY;KACZ,eAAe;KACf,kBAAkB;CACtB;;CAEA;KACI,mBAAmB;KACnB,WAAW;CACf;;CAEA;KACI,gBAAgB;KAChB,WAAW;CACf;;CAEA,mBAAmB;;CAEnB,UAAU;CACV;KACI,aAAa;KACb,aAAa;KACb,SAAS;CACb;;CAEA;KACI,eAAe;KACf,mBAAmB;CACvB;;CAEA;KACI,WAAW;KACX,YAAY;KACZ,oBAAoB;CACxB;;CAEA,WAAW;CACX;KACI,OAAO;KACP,gBAAgB;KAChB,aAAa;KACb,kBAAkB;CACtB;;EAEC;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;EACtB;;CAED;KACI,eAAe;KACf,mBAAmB;CACvB;;CAEA;KACI,WAAW;KACX,yBAAyB;KACzB,mBAAmB;CACvB;;CAEA;;KAEI,sBAAsB;KACtB,YAAY;KACZ,kBAAkB;KAClB,iBAAiB;KACjB,kBAAkB;KAClB,sBAAsB;KACtB,gBAAgB;KAChB,uBAAuB;KACvB,kBAAkB;KAClB,mBAAmB;KACnB,YAAY;CAChB;;CAEA,gBAAgB;CAChB;;;KAGI,WAAW;CACf;;;CAGA,gBAAgB;CAChB;;;KAGI,YAAY;CAChB;;CAEA;;;KAGI,YAAY;CAChB;;CAEA;;;KAGI,YAAY;CAChB;;CAEA;;;KAGI,YAAY;CAChB;;CAEA;KACI,mBAAmB;CACvB;;CAEA;KACI,aAAa;KACb,yBAAyB;KACzB,kBAAkB;KAClB,gBAAgB;KAChB,iBAAiB;CACrB;;;CAGA,QAAQ;CACR;KACI,gBAAgB;KAChB,kBAAkB;CACtB;;CAEA;KACI,YAAY;KACZ,YAAY;KACZ,eAAe;KACf,sBAAsB;KACtB,kBAAkB;CACtB;;CAEA,WAAW;CACX,eAAe;CACf;;;;;;;;;;;;;;;;;;;;IAoBG;;CAEH;KACI,aAAa;KACb,yBAAyB;KACzB,WAAW;KACX,QAAQ;CACZ;;CAEA,UAAU;CACV;KACI,yBAAyB;KACzB,aAAa;KACb,mBAAmB;KACnB,kBAAkB;CACtB;;CAEA,SAAS;CACT;KACI,aAAa;KACb,mBAAmB;KACnB,kBAAkB;CACtB;;CAEA;KACI,eAAe;KACf,WAAW;KACX,WAAW;KACX,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,WAAW;CACf;;CAEA;;KAEI,OAAO;KACP,YAAY;KACZ,sBAAsB;KACtB,kBAAkB;CACtB;;CAEA;KACI,aAAa;KACb,gBAAgB;CACpB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,kBAAkB;KAClB,kBAAkB;CACtB;;CAEA,kBAAkB;EACjB;IACE,eAAe;KACd,WAAW;KACX,iBAAiB;;CAErB;;CAEA,UAAU;CACV;KACI,yBAAyB;KACzB,aAAa;KACb,kBAAkB;KAClB,kBAAkB;CACtB;;CAEA,sBAAsB;CACtB;IACG,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;CACtB;;CAEA,OAAO;CACP;KACI,iBAAiB;CACrB;;CAEA;KACI,yBAAyB;KACzB,gBAAgB;KAChB,kBAAkB;KAClB,iBAAiB;KACjB,gBAAgB;KAChB,eAAe;CACnB;;CAEA;KACI,mBAAmB;CACvB;;CAEA,SAAS;CACT,yBAAyB;CACzB;IACG,0BAA0B;KACzB,iBAAiB;KACjB,iBAAiB;CACrB;;CAEA;KACI,qBAAqB;KACrB,iBAAiB;KACjB,sBAAsB;KACtB,kBAAkB;KAClB,eAAe;KACf,cAAc;KACd,qBAAqB;KACrB,mBAAmB;CACvB;;;CAGA;KACI,cAAc;KACd,sBAAsB;CAC1B;;CAEA,gCAAgC;;CAEhC,YAAY;CACZ;KACI,yBAAyB;KACzB,WAAW;KACX,YAAY;KACZ,aAAa;KACb,aAAa;KACb,sBAAsB;KACtB,8BAA8B;KAC9B,kBAAkB;KAClB,gBAAgB;KAChB,SAAS;KACT,sBAAsB;CAC1B;;CAEA,OAAO;CACP;KACI,kBAAkB;KAClB,aAAa;KACb,mBAAmB;KACnB,eAAe;KACf,gBAAgB;KAChB,mBAAmB;CACvB;;CAEA,WAAW;CACX;KACI,gBAAgB;KAChB,UAAU;KACV,SAAS;KACT,oCAAoC;KACpC,eAAe;KACf,YAAY;KACZ,gBAAgB;KAChB,kBAAkB;CACtB;;CAEA,aAAa;CACb;KACI,iBAAiB;KACjB,iDAAiD;KACjD,eAAe;KACf,kBAAkB;CACtB;;CAEA,aAAa;CACb;KACI,kBAAkB;KAClB,kBAAkB;KAClB,cAAc;KACd,iDAAiD;KACjD,eAAe;KACf,gBAAgB;CACpB;;CAEA,WAAW;CACX;KACI,kBAAkB;KAClB,WAAW;KACX,SAAS;KACT,aAAa;KACb,eAAe;KACf,gBAAgB;KAChB,+BAA+B;KAC/B,YAAY;KACZ,oBAAoB;KACpB,aAAa;KACb,UAAU;KACV,mBAAmB;CACvB;;CAEA,uBAAuB;CACvB;KACI,kBAAkB;KAClB,WAAW;CACf;;CAEA,cAAc;CACd;KACI,0BAA0B;CAC9B;;CAEA,mBAAmB;CACnB;KACI,aAAa;KACb,gBAAgB;KAChB,kBAAkB;KAClB,eAAe;KACf,aAAa;KACb,gBAAgB;KAChB,gCAAgC;CACpC;;CAEA;KACI,cAAc;CAClB;;CAEA,WAAW;CACX;KACI,iBAAiB;KACjB,WAAW;CACf;;CAEA,UAAU;CACV;KACI,kBAAkB;KAClB,eAAe;KACf,iBAAiB;KACjB,eAAe;CACnB;;CAEA,OAAO;CACP;KACI,oBAAoB;KACpB,mBAAmB;KACnB,WAAW;KACX,YAAY;KACZ,iBAAiB;KACjB,eAAe;KACf,kBAAkB;KAClB,eAAe;CACnB;;CAEA,aAAa;CACb;KACI,UAAU;CACd;;CAEA;KACI,0CAA0C;KAC1C,kBAAkB;CACtB;;CAEA,wBAAwB;CACxB,UAAU;AACX,UAAU;AACV;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,aAAa,EAAE,WAAW;AAC5B;;AAEA;IACI,kBAAkB;KACjB,aAAa;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,WAAW;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;KACK,WAAW;KACX,yBAAyB;KACzB,mBAAmB;CACvB;;CAEA;;KAEI,sBAAsB;KACtB,YAAY;KACZ,kBAAkB;KAClB,iBAAiB;KACjB,kBAAkB;KAClB,sBAAsB;KACtB,gBAAgB;KAChB,uBAAuB;KACvB,kBAAkB;KAClB,mBAAmB;KACnB,YAAY;CAChB;;CAEA,gBAAgB;CAChB;;KAEI,WAAW;CACf;;CAEA;;KAEI,YAAY;CAChB;;EAEC;;KAEG,YAAY;CAChB;;GAEE;;KAEE,YAAY;CAChB;;IAEG;;KAEC,WAAW;CACf;;IAEG;;KAEC,YAAY;CAChB;;KAEI;;KAEA,WAAW;CACf;;;;CAIA;KACI,mBAAmB;CACvB;;EAEC;KACG,mBAAmB;CACvB;;CAEA,mBAAmB;CACnB;KACI,cAAc;KACd,eAAe;KACf,mBAAmB;KACnB,kBAAkB;CACtB;;CAEA;IACG,eAAe;IACf,cAAc;CACjB;;CAEA;IACG,aAAa;IACb,mBAAmB;CACtB;;CAEA;IACG,kBAAkB;CACrB","sourcesContent":[" * {\n     box-sizing: border-box;\n     font-family: \"Noto Sans KR\", sans-serif;\n }\n\n body {\n     margin: 0;\n     /* 2025.10.28 background 삭제 */\n }\n\n /* 2025.10.23 로그인 화면 */\n\n .login-container {\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     height: 100vh;\n     /* 중앙 정렬용 */\n }\n\n .login-box {\n     width: 420px;\n     /* 👉 원하는 가로 넓이 지정 */\n     background: #fff;\n     padding: 40px 30px;\n     border: 1px solid #ddd;\n     box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n     text-align: center;\n     border-radius: 4px;\n }\n\n .logo {\n     width: 250px;\n     margin-bottom: 20px;\n }\n\n .login-section {\n     text-align: left;\n }\n\n .login-label {\n     font-size: 14px;\n     color: #333;\n     display: block;\n     margin-bottom: 6px;\n }\n\n input[type=\"id\"],\n input[type=\"password\"] {\n     width: 100%;\n     padding: 10px;\n     border: 1px solid #8c8f94;\n     border-radius: 3px;\n     margin-bottom: 14px;\n     font-size: 14px;\n }\n\n .password-wrap {\n     position: relative;\n }\n\n .toggle-password {\n     position: absolute;\n     right: 10px;\n     top: 7px;\n     background: none;\n     border: none;\n     cursor: pointer;\n     font-size: 16px;\n     color: #555;\n }\n\n .remember {\n     display: flex;\n     align-items: center;\n     margin-bottom: 20px;\n }\n\n .remember label {\n     margin: 0 0 0 6px;\n     font-size: 13px;\n     color: #555;\n }\n\n .login-btn {\n     width: 100%;\n     background-color: #2271b1;\n     color: #fff;\n     border: none;\n     border-radius: 3px;\n     padding: 10px 0;\n     font-size: 15px;\n     cursor: pointer;\n }\n\n .login-btn:hover {\n     background-color: #135e96;\n }\n\n .back {\n     display: inline-block;\n     margin-top: 16px;\n     font-size: 13px;\n     color: #2271b1;\n     text-decoration: none;\n }\n\n .back:hover {\n     text-decoration: underline;\n }\n\n\n /* 2025.10.20 제품관리 css 작성중 */\n .manager-header {\n     display: flex;\n     justify-content: space-between;\n     background-color: #6b93b0;\n     color: #fff;\n     padding: 10px 20px;\n     font-size: 18px;\n     align-items: center;\n }\n\n /* 2025.10.27 lang 변경 */\n  .lang {\n     display: flex;\n     align-items: center;\n     height: 40px;\n }\n\n .lang select {\n     margin: 0;\n     padding: 6px 30px 6px 10px;\n     font-size: 14px;\n     border: 0.5px solid #ccc;\n     border-radius: 6px;\n     height: 36px;\n     line-height: 1.2;\n     box-sizing: border-box;\n     background-color: #fff;\n     appearance: none;\n     -webkit-appearance: none;\n     -moz-appearance: none;\n     background: url(\"data:image/svg+xml;utf8,<svg fill='%23000' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\") no-repeat right 5px center;\n     background-color: #fff;\n }\n\n\n .manager-nav {\n     display: flex !important;\n     background: #5c88ab;\n     text-align: center;\n }\n\n .manager-nav .admin-menu {\n     flex: 1;\n     background: transparent;\n     color: #fff;\n     padding: 12px;\n     font-size: 16px;\n     border: none;\n     cursor: pointer;\n }\n\n .manager-nav .admin-menu.selected {\n     font-weight: bold;\n     background: #4e7394;\n }\n\n .product-manager {\n     display: flex;\n     padding: 20px;\n     gap: 20px;\n     align-items: flex-start;\n }\n\n /* 제품 목록 */\n .product-list {\n     background: #6b93b0;\n     color: #fff;\n     padding: 20px;\n     width: 220px;\n     display: flex;\n     flex-direction: column;\n     justify-content: space-between;\n     border-radius: 4px;\n\n     position: sticky;\n     top: 20px;\n     /* 스크롤 시 상단에서 20px 떨어진 상태로 고정 */\n     align-self: flex-start;\n }\n\n .product-list h2 {\n     text-align: center;\n     margin-top: 0;\n }\n\n .product-list ul {\n     list-style: none;\n     padding: 0;\n     background: rgba(255, 255, 255, 0.1);\n     margin: 10px 0;\n     height: 280px;\n     overflow-y: auto;\n }\n\n .product-list li {\n     padding: 8px 12px;\n     border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n     cursor: pointer;\n }\n\n /* 신규 버튼 */\n .new-btn {\n     align-self: flex-end;\n     background: #4e7394;\n     color: #fff;\n     border: none;\n     padding: 8px 14px;\n     cursor: pointer;\n     border-radius: 4px;\n }\n\n /* 제품 상세 */\n .product-detail {\n     flex: 1;\n     background: #fff;\n     padding: 20px;\n     border: 1px solid #d0d7de;\n     border-radius: 4px;\n }\n\n .form-row {\n     display: flex;\n     align-items: center;\n     margin-bottom: 12px;\n }\n\n .form-row label {\n     width: 80px;\n     flex-shrink: 0;\n }\n\n .form-row input[type=\"text\"],\n .form-row textarea {\n     flex: 1;\n     padding: 6px;\n     border: 1px solid #ccc;\n     border-radius: 4px;\n }\n\n .form-row textarea {\n     height: 60px;\n     resize: vertical;\n }\n\n .form-row select {\n     flex: 0 0 250px;\n     /* 가로 폭 줄이기 */\n     padding: 6px 32px 6px 10px;\n     /* 오른쪽에 여백 줘서 화살표 안겹치게 */\n     border: 1px solid #ccc;\n     border-radius: 4px;\n     background-color: #fff;\n     appearance: none;\n     -webkit-appearance: none;\n     -moz-appearance: none;\n     background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23555' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E\");\n     background-repeat: no-repeat;\n     background-position: right 12px center;\n     background-size: 10px 6px;\n     cursor: pointer;\n }\n\n .form-row select:focus {\n     outline: none;\n     border-color: #4e7394;\n     box-shadow: 0 0 0 2px rgba(78, 115, 148, 0.2);\n }\n\n /* 메인사진 영역 */\n .main-photo-row {\n     align-items: flex-start;\n }\n\n .main-photo-wrap {\n     flex: 1;\n     display: flex;\n     flex-direction: column;\n     gap: 8px;\n     padding-bottom: 18px;\n }\n\n .main-photo-wrap input[type=\"file\"] {\n     border: 1px solid #ccc;\n     border-radius: 4px;\n     padding: 6px;\n     background: #ffffff;\n }\n\n .main-photo-preview {\n     width: 100%;\n     min-height: 180px;\n     border: 1px solid #ccc;\n     border-radius: 6px;\n     background: #f6f8fb;\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     overflow: hidden;\n     text-align: center;\n     color: #777;\n }\n\n .main-photo-preview img {\n     max-width: 100%;\n     max-height: 100%;\n     object-fit: contain;\n     border-radius: 4px;\n }\n\n .img-btn {\n     margin-left: 10px;\n     padding: 6px 10px;\n     background: #4e7394;\n     color: #fff;\n     border: none;\n     border-radius: 4px;\n     cursor: pointer;\n }\n\n .file-info {\n     font-size: 13px;\n     color: #555;\n }\n\n .file-item {\n     display: flex;\n     align-items: center;\n     gap: 4px;\n     padding: 4px 0;\n     font-size: 14px;\n     line-height: 1.4;\n }\n\n .file-item svg {\n     width: 14px;\n     height: 14px;\n     flex-shrink: 0;\n     vertical-align: middle;\n     margin-top: -0.5px;\n }\n\n .file-item .file-name {\n     flex: none;\n     overflow: hidden;\n     text-overflow: ellipsis;\n     white-space: nowrap;\n     color: #0048ff;\n     cursor: pointer;\n     margin-right: 4px;\n     display: flex;\n     align-items: center;\n }\n\n .file-item .remove-btn {\n     color: #999;\n     background: none;\n     border: none;\n     font-size: 15px;\n     cursor: pointer;\n     padding: 0 2px;\n     line-height: 1;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     transition: 0.2s;\n }\n\n .file-item .remove-btn:hover {\n     color: #ff4444;\n }\n\n /* 2025.10.27 class 변경 */\n .file-row {\n     display: flex;\n }\n\n .file-row>.file-item {\n     margin-right: 8px;\n }\n\n /* 미리보기 행 확장 */\n .preview-row {\n     align-items: flex-start;\n     padding-top: 18px;\n }\n\n /* 기존 editor-area 대신 새 preview-area */\n .preview-area {\n     flex: 1;\n     border: 1px solid #ccc;\n     border-radius: 6px;\n     background-color: #f6f8fb;\n     padding: 20px;\n     text-align: center;\n     color: #555;\n     min-height: 300px;\n     /* 기본 높이 크게 */\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     overflow: hidden;\n     flex-direction: column;\n }\n\n /* 업로드된 이미지 미리보기용 */\n .preview-area img {\n     max-width: 100%;\n     max-height: 100%;\n     object-fit: contain;\n     border-radius: 4px;\n }\n\n /* 하단 버튼 */\n .footer-row {\n     display: flex;\n     justify-content: space-between;\n     margin-top: 20px;\n     align-items: center;\n }\n\n .btn-group {\n     display: flex;\n     gap: 8px;\n }\n\n .edit-btn,\n .delete-btn {\n     padding: 8px 16px;\n     border: none;\n     cursor: pointer;\n     border-radius: 4px;\n }\n\n .edit-btn {\n     background: #4e7394;\n     color: #fff;\n }\n\n .delete-btn {\n     background: #ccc;\n     color: #000;\n }\n\n /* 게시판 관리 css 작성중 */\n\n /* 메인 영역 */\n .admin-body {\n     display: flex;\n     padding: 20px;\n     gap: 20px;\n }\n\n .board-settings h3 {\n     font-size: 14px;\n     margin-bottom: 10px;\n }\n\n .board-settings input[type=\"text\"] {\n     width: 100%;\n     padding: 6px;\n     margin: 4px 0 10px 0;\n }\n\n /* 게시판 메인 */\n .board-main {\n     flex: 1;\n     background: #fff;\n     padding: 15px;\n     border-radius: 8px;\n }\n\n  .board-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 12px;\n  }\n\n .board-header h4 {\n     font-size: 16px;\n     margin-bottom: 10px;\n }\n\n .board-table {\n     width: 100%;\n     border-collapse: collapse;\n     table-layout: fixed;\n }\n\n .board-table th,\n .board-table td {\n     border: 1px solid #ccc;\n     padding: 8px;\n     text-align: center;\n     padding: 8px 12px;\n     text-align: center;\n     border: 1px solid #ddd;\n     overflow: hidden;\n     text-overflow: ellipsis;\n     /* 내용이 길면 ... 처리 */\n     white-space: nowrap;\n     /* 줄 바꿈 방지 */\n }\n\n /* 특정 컬럼 너비 조정 */\n .board-table th:nth-child(1),\n /* 조회수 */\n .board-table td:nth-child(1) {\n     width: 50px;\n }\n\n\n /* 특정 컬럼 너비 조정 */\n .board-table th:nth-child(3),\n /* 조회수 */\n .board-table td:nth-child(3) {\n     width: 100px;\n }\n\n .board-table th:nth-child(4),\n /* 생성시간 */\n .board-table td:nth-child(4) {\n     width: 100px;\n }\n\n .board-table th:nth-child(5),\n /* 답글 */\n .board-table td:nth-child(5) {\n     width: 100px;\n }\n\n .board-table th:nth-child(6),\n /* 첨부 */\n .board-table td:nth-child(6) {\n     width: 100px;\n }\n\n .board-table th {\n     background: #f0f4f8;\n }\n\n .footer-box {\n     display: flex;\n     justify-content: flex-end;\n     /* 내부 콘텐츠를 오른쪽으로 */\n     margin-top: 16px;\n     /* 위쪽 여백 (선택사항) */\n }\n\n\n /* 검색창 */\n .search-area {\n     margin-top: 12px;\n     text-align: center;\n }\n\n .search-area input {\n     padding: 8px;\n     width: 300px;\n     max-width: 100%;\n     border: 1px solid #ccc;\n     border-radius: 4px;\n }\n\n /* 페이지네이션 */\n /* 2025.10.31 */\n /* .edit-pagination {\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     gap: 15px;\n     margin: 25px 0 0;\n     padding-bottom: 20px;\n }\n\n .edit-pagination button {\n     background: none;\n     border: none;\n     font-size: 1rem;\n     cursor: pointer;\n     color: #000;\n }\n\n .edit-pagination .active {\n     font-weight: 500;\n     text-decoration: underline;\n } */\n\n .btn-group {\n     display: flex;\n     justify-content: flex-end;\n     /* 오른쪽 정렬 */\n     gap: 8px;\n }\n\n /* 섹션 구분 */\n .board-section {\n     border: 1px solid #cfd6e3;\n     padding: 20px;\n     margin-bottom: 25px;\n     border-radius: 6px;\n }\n\n /* 행 정렬 */\n .row {\n     display: flex;\n     align-items: center;\n     margin-bottom: 8px;\n }\n\n .row label {\n     font-size: 14px;\n     color: #222;\n     width: 80px;\n     flex-shrink: 0;\n }\n\n .right {\n     font-size: 14px;\n     color: #444;\n }\n\n .row input[type=\"text\"],\n .row textarea {\n     flex: 1;\n     padding: 6px;\n     border: 1px solid #ccc;\n     border-radius: 4px;\n }\n\n .row textarea {\n     height: 400px;\n     resize: vertical;\n }\n\n .row-file {\n     display: flex;\n     align-items: center;\n     text-align: center;\n     margin-bottom: 8px;\n }\n\n /* 2025.10.29 수정 */\n  .row-file label {\n    font-size: 14px;\n     color: #222;\n     margin-right: 8px;\n\n }\n\n /* 내용 박스 */\n .content-box {\n     border: 1px solid #99a3b3;\n     height: 120px;\n     border-radius: 4px;\n     margin: 8px 0 16px;\n }\n\n /* 2025.10.27 css 추가 */\n .board-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n }\n\n /* 버튼 */\n .btn-box {\n     text-align: right;\n }\n\n .btn-box button {\n     border: 1px solid #6b7a90;\n     background: #fff;\n     border-radius: 4px;\n     padding: 4px 10px;\n     margin-left: 5px;\n     cursor: pointer;\n }\n\n .btn-box button:hover {\n     background: #e8edf4;\n }\n\n /* 첨부파일 */\n /* 2025.10.27 class명 변경 */\n .row-detail-file {\n    /* 2025.10.25 margin값 변경 */\n     margin-left: 20px;\n     text-align: right;\n }\n\n .row-detail-file a {\n     display: inline-block;\n     padding: 6px 10px;\n     border: 1px solid #ccc;\n     border-radius: 4px;\n     font-size: 14px;\n     color: #0048FF;\n     text-decoration: none;\n     background: #f9f9f9;\n }\n\n\n .row-detail-file svg {\n     flex-shrink: 0;\n     vertical-align: middle;\n }\n\n /* 2025.10.25 메뉴 관리 페이지 css 작성 */\n\n /* 메뉴 사이드바 */\n .menu-sidebar {\n     background-color: #6b93b0;\n     color: #fff;\n     width: 220px;\n     padding: 20px;\n     display: flex;\n     flex-direction: column;\n     justify-content: space-between;\n     border-radius: 6px;\n     position: sticky;\n     top: 20px;\n     align-self: flex-start;\n }\n\n /* 제목 */\n .menu-title {\n     text-align: center;\n     margin-top: 0;\n     margin-bottom: 10px;\n     font-size: 22px;\n     font-weight: 700;\n     margin-bottom: 16px;\n }\n\n /* 메뉴 리스트 */\n .menu-list {\n     list-style: none;\n     padding: 0;\n     margin: 0;\n     background: rgba(255, 255, 255, 0.1);\n     /* 2025.10.31 */\n     height: 100%;\n     overflow-y: auto;\n     border-radius: 4px;\n }\n\n /* 상위 메뉴 항목 */\n .menu-item {\n     padding: 8px 12px;\n     border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n     cursor: pointer;\n     position: relative;\n }\n\n /* 상위 메뉴 항목 */\n .menu-item {\n     position: relative;\n     padding: 10px 12px;\n     /* 오른쪽 여백 확보 */\n     border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n     cursor: pointer;\n     line-height: 1.4;\n }\n\n /* 화살표 고정 */\n .arrow {\n     position: absolute;\n     right: 10px;\n     top: 12px;\n     /* 세로 중앙 정렬 */\n     transform: none;\n     font-size: 0.8em;\n     transition: transform 0.3s ease;\n     opacity: 0.8;\n     pointer-events: none;\n     /* 클릭 방해 금지 */\n     z-index: 2;\n     /* 스크롤 영역 안에서도 고정 */\n }\n\n /* 2025.10.27 plus 추가 */\n .plus {\n     position: absolute;\n     right: 10px;\n }\n\n /* 펼쳐졌을 때 회전 */\n .menu-item.active .arrow {\n     transform: rotate(-180deg);\n }\n\n /* 서브메뉴 (아코디언 숨김) */\n .submenu-list {\n     display: none;\n     list-style: none;\n     padding-left: 15px;\n     margin-top: 5px;\n     max-height: 0;\n     overflow: hidden;\n     transition: max-height 0.3s ease;\n }\n\n .menu-item.active .submenu-list {\n     display: block;\n }\n\n /* 펼쳐졌을 때 */\n .menu-item.active .submenu-list {\n     max-height: 300px;\n     /* 충분한 높이 */\n }\n\n /* 서브 항목 */\n .submenu-item {\n     padding: 10px 10px;\n     cursor: default;\n     font-size: 0.95em;\n     cursor: pointer;\n }\n\n /* 버튼 */\n .btn-add {\n     align-self: flex-end;\n     background: #4e7394;\n     color: #fff;\n     border: none;\n     padding: 8px 14px;\n     cursor: pointer;\n     border-radius: 4px;\n     margin-top: 5px;\n }\n\n /* 스크롤바 스타일 */\n .menu-list::-webkit-scrollbar {\n     width: 6px;\n }\n\n .menu-list::-webkit-scrollbar-thumb {\n     background-color: rgba(255, 255, 255, 0.3);\n     border-radius: 3px;\n }\n\n /* 2025.10.28 메뉴 팝업 수정 */\n /* 메뉴 팝업 */\n/* 모달 기본 */\n.menu-modal {\n  display: none;\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n}\n\n.menu-modal-content {\n  background: #fff;\n  width: 600px;\n  padding: 25px;\n  border-radius: 12px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.menu-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f2f4f8;\n  padding: 10px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n/* 2025.10.29 수정 */\n.submenu-modal {\n  margin: 8px 0 15px 20px;\n  padding: 0;\n  list-style: none;\n  display: none; /* 기본은 접힘 */\n}\n\n.submenu-modal > li {\n    margin-bottom: 8px;\n     display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f2f4f8;\n  padding: 10px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.menu-item.open .submenu-list {\n  display: block; /* 열리면 표시 */\n}\n\n.sort-btns button {\n  background: #6b93b0;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 3px 6px;\n  cursor: pointer;\n}\n\n.sort-btns button:hover {\n  background: #587d95;\n}\n\n.modal-buttons {\n  text-align: right;\n  margin-top: 10px;\n}\n\n.modal-buttons button {\n  background: #6b93b0;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 8px 14px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.modal-buttons .close-menu-modal {\n  background: #aaa;\n}\n\n/* 2025.10.25 제품관리 테이블 추가 */\n.product-table {\n     width: 100%;\n     border-collapse: collapse;\n     table-layout: fixed;\n }\n\n .product-table th,\n .product-table td {\n     border: 1px solid #ccc;\n     padding: 8px;\n     text-align: center;\n     padding: 8px 12px;\n     text-align: center;\n     border: 1px solid #ddd;\n     overflow: hidden;\n     text-overflow: ellipsis;\n     /* 내용이 길면 ... 처리 */\n     white-space: nowrap;\n     /* 줄 바꿈 방지 */\n }\n\n /* 특정 컬럼 너비 조정 */\n .product-table th:nth-child(1),\n .product-table td:nth-child(1) {\n     width: 20px;\n }\n\n .product-table th:nth-child(2),\n .product-table td:nth-child(2) {\n     width: 100px;\n }\n\n  .product-table th:nth-child(3),\n .product-table td:nth-child(3) {\n     width: 200px;\n }\n\n   .product-table th:nth-child(4),\n .product-table td:nth-child(4) {\n     width: 150px;\n }\n \n    .product-table th:nth-child(5),\n .product-table td:nth-child(5) {\n     width: 50px;\n }\n\n    .product-table th:nth-child(6),\n .product-table td:nth-child(6) {\n     width: 150px;\n }\n\n     .product-table th:nth-child(7),\n .product-table td:nth-child(7) {\n     width: 40px;\n }\n\n\n\n .product-table th {\n     background: #f0f4f8;\n }\n\n  .product-preview {\n     align-items: center;\n }\n\n /* 업로드된 이미지 미리보기용 */\n .product-preview img {\n     max-width: 25%;\n     max-height: 25%;\n     object-fit: contain;\n     border-radius: 4px;\n }\n\n .Caution {\n    font-size: 12px;\n    color: #d80a0a;\n }\n\n .manager-btn {\n    display: flex;\n    align-items: center;\n }\n\n .title {\n    margin-right: 16px;\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
